<template>
  <div class="mt-auto mb-auto">
    <v-btn class="black--text  text" to="/carrito" icon>
      <v-icon>mdi-cart-plus</v-icon><sub class="blue--text ">
        <p class="font-weight-bold">{{ NumItems }}
        </p>
      </sub>
    </v-btn>
  </div>
</template>
  
<script>
export default {
  data() {
    return {
      title: 'Mi Componente Vue',
      NumItems: 0,
      ItemsCarrito: []
    }
  },
  created() {
    let num = this.$parent.NumCarritoFromLocalStorage;
    this.NumItems = num == null ? 0: num;
    this.ItemsCarrito = this.$parent.ItemsCarritoFromLocalStorage;
  },
  methods: {

  }
}
</script>
<style scoped></style>